export default "__VITE_ASSET__ByPXgxMK__";